import { Modal, Spin, Tooltip, Progress, message, Upload, UploadProps } from 'antd';
import AdminLayout from 'components/layouts/AdminLayout';
import { useEffect, useState } from 'react'
import { FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { TranslateString, downloadSettingsBlob } from 'Utils/Common';
import { InboxOutlined, EyeOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import SingleLoanServices from "services/services/SingleLoanServices";
import moment from 'moment';
import { CloudFileBasePath } from 'constants/Constants';
import UserService from 'services/UserService';


const { Dragger } = Upload;

const FilesLayout = (props: any) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [show, setShow] = useState<any>(false);
    const [showFile, setShowFile] = useState<any>(false);
    const [showFileTitle, setShowFileTitle] = useState<any>("");
    const [showFilePath, setShowFilePath] = useState<any>("");
    const [dataFor, setDataFor] = useState<any>(null);
    const intl = useIntl();
    const [fileUploadProgress, setUploadProgress] = useState<any>(0);
    const [fileUploadProgressStatus, setUploadProgressStatus] = useState<any>('');
    const [contractUpdatedAt, setContractUpdatedAt] = useState<any>(null);
    const [materialUpdatedAt, setMaterialUpdatedAt] = useState<any>(null);

    const [contractFilePath, setContractFilePath] = useState<any>('');
    const [contractFileId, setContractFileId] = useState<any>('');

    const [materialFilePath, setMaterialFilePath] = useState<any>('');
    const [materialFileId, setMaterialFileId] = useState<any>('');

    const url = process.env.REACT_APP_API_URL_TARGET + "update_settings";

    useEffect(() => {
        getSettingsData();
    }, [props])

    const downloadBlobFile = async (id:any) => {
        setLoading(true);
        await downloadSettingsBlob(id);
        setLoading(false);
    }

    let dragProps: UploadProps = {
		...props,
		name: 'file',
		multiple: false,
		action: url,
		headers:{
			Authorization : `Bearer ${UserService.getToken()}`
		},
		data: {
			key: dataFor?.key
		},
		onChange(info) {
			const { status } = info.file;
			if (status !== 'uploading') {
				// console.log('file on change updateing - ',info)
				// setShowDragger(true);
				// console.log(info.file, info.fileList);

			}
			if (status === 'done') {
				if (info?.file?.response?.code === 200) {
					message.success(`${info.file.name} ` + intl.formatMessage({ id: 'file_uploaded_successfully' }) );
                    setShow(false);
                    getSettingsData();
				} else if (info?.file?.response?.code === 500) {
					message.error(info?.file?.response?.message);
                }
			} else if (status === 'error') {
				message.error(info?.file?.response?.message);
				setUploadProgress(0);
				setUploadProgressStatus('');
			}

		},
		onDrop(e) {
			// console.log('Dropped files', e.dataTransfer.files);
		},
		beforeUpload(file, fileList) {
			setUploadProgress(0);
			setUploadProgressStatus('');
			
		}
	};

    function setFileData(fileData:any): any {
        fileData?.map((element:any) => {
            if(element?.key === 'ador_contract'){
                setContractUpdatedAt(element?.updated_at);
                setContractFilePath(element?.value);
                setContractFileId(element?.setting_id);
            } else if (element?.key === 'marketing_materials'){
                setMaterialUpdatedAt(element?.updated_at);
                setMaterialFilePath(element?.value);
                setMaterialFileId(element?.setting_id);
            }
        });
    }
    
    function getSettingsData(): any {
        setLoading(true);
        SingleLoanServices
        .getSettingsData()
        .then((response: any) => {
            if (response?.data?.code === 200) {
                let fileData = response?.data?.data;
                if( fileData?.length > 0 ){
                    setFileData(fileData)
                } 
            }
            setLoading(false);
        })
        .catch((err: any) => {
            console.log(err)
            setLoading(false);
        });
    }

    const handleCancel = () => {
        setShow(false);
    };


    return (
        <>
            <AdminLayout>
                <Spin spinning={loading}>
                    <div className="ant-card ant-card-bordered cu-mb-10 cu-px-10 w-100 text-left cu-tab-text">
                        <Link to={`/housingcompany`}>
                            <h4 className="cu-m-0 cu-p-0">
                                <button className="ant-btn cu-border-0 back-btn text-primary"><FaArrowLeft style={{ fontWeight: 900, fontSize: '18px' }} /></button>
                                &nbsp;
                                <button className="ant-btn cu-border-0 h4 pl-0 align-middle mb-0">{TranslateString('file_management')}</button>
                            </h4>
                        </Link>
                    </div>


                    <div className='cu-table-small ant-table ant-table-bordered'>
                        <table className="table table-sm table-bordered table-striped text-left mt-2 m-0">
                            <thead className='ant-table-thead'>
                                <tr >
                                    <th className="ant-table-cell fw-bold">{TranslateString('File Description')}</th>
                                    <th className="ant-table-cell fw-bold text-left">{TranslateString('Last Import Done (Date and time)')}</th>
                                    <th className="ant-table-cell fw-bold text-left ps-5">{TranslateString('actions')}</th>
                                </tr>
                            </thead>
                            <tbody className="">
                                <tr key={Math.random()} >
                                    <td className="text-left">{TranslateString('ador_contract')}</td>
                                    <td className="text-left ">{ contractUpdatedAt === null ? "" : moment(contractUpdatedAt).format("DD-MM-YYYY h:mm:ss") }</td>
                                    <td className="text-left" >
                                        <div className="d-flex justify-content-start ps-5">
                                            <div>
                                                <button onClick={() => {
                                                    setOpen(!open);
                                                    setDataFor({key:'ador_contract',  lable: intl.formatMessage({ id: 'ador_contract'}), entity_type:'ador_contract' });
                                                    setShow(!show);
                                                }} className="btn btn-sm cu-btn-green py-0">{TranslateString('Import')}</button>
                                            </div>
                                            <div>&nbsp;&nbsp;</div>
                                            <div className='' >
                                                {
                                                    contractFilePath && 
                                                    <a 
                                                    // href={CloudFileBasePath + contractFilePath}
                                                     style={{ color: "inherit" }} 
                                                    // target="_blank"
                                                    href='javascript:void(0)'
                                                    onClick={() => {
                                                        downloadBlobFile(contractFileId)
                                                    }}
                                                     >
                                                        <Tooltip title={TranslateString('view')}>
                                                            <EyeOutlined
                                                                className="fs-5"
                                                            />                                                              
                                                        </Tooltip>
                                                    </a>
                                                }
                                                
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                <tr key={Math.random()} >
                                    <td className="text-left">{TranslateString('marketing_materials')}</td>
                                    <td className="text-left ">{ materialUpdatedAt === null ? "" : moment(materialUpdatedAt).format("DD-MM-YYYY h:mm:ss") }</td>
                                    <td className="text-left" >
                                        <div className="d-flex justify-content-start ps-5">
                                            <div>
                                                <button onClick={() => {
                                                    setOpen(!open);
                                                    setDataFor({key:'marketing_materials',  lable: intl.formatMessage({ id: 'marketing_materials'}), entity_type:'marketing_materials' });
                                                    setShow(!show);
                                                }} className="btn btn-sm cu-btn-green py-0">{TranslateString('Import')}</button>
                                            </div>
                                            <div>&nbsp;&nbsp;</div>
                                            <div className='' >
                                                {
                                                    materialFilePath && 
                                                    <a 
                                                    // href={CloudFileBasePath + materialFilePath} 
                                                    style={{ color: "inherit" }}
                                                    href='javascript:void(0)'
                                                    onClick={() => {
                                                        downloadBlobFile(materialFileId)
                                                    }}
                                                    >
                                                        <Tooltip title={TranslateString('view')}>
                                                            <EyeOutlined
                                                                className="fs-5"
                                                            />                                                              
                                                        </Tooltip>
                                                    </a>
                                                }
                                                
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </Spin>
            </AdminLayout>

            <Modal
                destroyOnClose
                title={TranslateString('Import') + " : " + dataFor?.lable || ""}
                className="bookingModal"
                open={show}
                footer={null}
                onCancel={handleCancel}
            >
            <Dragger
                {...dragProps}
                className="text-center"
                accept={'.pdf'}
            >
                <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                </p>
                <p className="ant-upload-text">{TranslateString('Click or drag file to this area to upload')}</p>
                <p className="ant-upload-hint">
                    {TranslateString('Support for a single upload. Strictly prohibit from uploading company data or other band files')}
                </p>
                {
                    fileUploadProgress > 0 ? <Progress percent={fileUploadProgress} size="small" status={fileUploadProgressStatus} /> : ''
                }
            </Dragger>
            </Modal>

            {/* <Modal
                destroyOnClose
                title={showFileTitle}
                open={showFile}
                footer={null}
                width={1000}
                onCancel = {
                    () => {
                        setShowFile(false)
                    }
                }
            >
                <iframe src={showFilePath} width="100%" height="100%" />
            </Modal> */}
        </>
    );

}

export default FilesLayout;